// Навигация — нижний таббар (стиль см. src/styles/theme.css, класс .nav-bar). 4 вкладки, не
// 8 по числу экранов ТЗ раздел 3.3: устройства объединены с "Моя подписка", платежи/отмена/
// промокод — на одной странице "Ещё" (см. App.tsx, MySubscriptionScreen.tsx, MoreScreen.tsx) —
// 7 отдельных вкладок не помещались на узком экране Mini App (найдено пользователем 2026-08-20).
// NavLink сам проставляет класс "active" на текущий маршрут — CSS полагается именно на него,
// отдельной логики подсветки здесь нет.
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ROUTES = [
  { path: "/", key: "nav_plans" },
  { path: "/subscription", key: "nav_subscription" },
  { path: "/change-plan", key: "nav_change_plan" },
  { path: "/more", key: "nav_more" },
] as const;

export function NavBar() {
  const { t } = useTranslation();
  return (
    <nav className="nav-bar">
      {ROUTES.map(({ path, key }) => (
        <NavLink key={path} to={path} end={path === "/"}>
          {t(key)}
        </NavLink>
      ))}
    </nav>
  );
}
